<template>
  <draggable class="dragArea" tag="ul" :list="children" :group="{ name: 'g1' }">
    <li
      v-for="el in children"
      :key="`${el.id}-${el.name}`"
      class="no-style mt-1"
    >
      <v-row v-if="!el.edit">
        <v-col v-if="el.color" cols="1">
          <div class="circle" :style="{ backgroundColor: el.color }">
            {{ el.label }}
          </div>
        </v-col>
        <v-col :cols="el.color ? 11 : 12"
          ><h2 :class="computedSize" class="font-weight-regular">
            {{ getName(el) }} <span v-if="el.spotlight"> *</span>
          </h2>
        </v-col>

        <v-col cols="12">
          <v-chip v-if="el.logo" small light color="amber">Logo</v-chip>
          <div v-if="el.audiences" class="d-flex mt-3">
            <v-chip
              v-for="(tag, index) in el.audiences"
              :key="`tag-nested-${tag}-${depthInc}-${index}`"
              small
              class="mr-2"
            >
              {{ tag }}</v-chip
            >
          </div>
        </v-col>

        <v-col v-if="attrs.note && el.body" cols="12">
          <div class="pre-wrap" v-html="el.body"></div>
        </v-col>
      </v-row>
      <v-row v-if="el.edit">
        <v-col cols="2">
          <div class="circle" :style="{ backgroundColor: el.color }">
            {{ el.label }}
          </div>
        </v-col>
        <v-col cols="10">
          <ItemForm
            :key="newItem.id"
            :new-item="newItem"
            :colors="colors"
            :audiences="attrs.audiences"
            @submit="editCommit"
            @cancel="cancelEdit"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div
            v-if="attrs.controls"
            class="d-flex justify-end align-center flex-wrap"
          >
            <v-btn @click="editItem(el)" x-small color="white" class="" light
              >Edit</v-btn
            >
            <v-btn
              class="ml-2"
              @click="deleteItem(el)"
              x-small
              color="white"
              light
              >Delete</v-btn
            >
            <v-btn
              @click="togglePrefix(el)"
              x-small
              color="white"
              class="ml-2 mr-2"
              :class="getButtonClass(el)"
              light
              >{{ getButtonText(el) }}</v-btn
            >
          </div>
        </v-col>
      </v-row>

      <div v-if="!hideChildren">
        <NestedDraggable
          :children="el.children"
          :attrs="attrs"
          :item-model="itemModel"
          :depth="depthInc"
          :color="el.color"
          :label="el.label"
        />
      </div>
    </li>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";
import ItemForm from "@/views/user/exercises/eco-system/ItemForm";

import { checkPopulated } from "@/utils/types";

// const itemModel = {
//   id: "",
//   name: "",
//   body: "",
//   label: "",
//   color: "",
//   index: "",
//   edit: false,
//   allowPrefix: false,
//   children: [],
//   spotlight: false,
// };

export default {
  name: "NestedDraggable",
  data() {
    return {
      edit: false,
      newItem: {
        ...this.itemModel,
      },
      // newName: "",
      // newColor: "",
      // newBody: "",
      // newLabel: "",
      // newPrefix: false,
      // newSpotlight: false,
      depthInc: this.depth + 1,
      colors: [
        { title: "None", color: "" },
        { title: "Red", color: "#F44336" },
        { title: "Dark Red", color: "#B71C1C" },
        { title: "Pink", color: "#E91E63" },
        { title: "Purple", color: "#9C27B0" },
        { title: "Dark Purple", color: "#673AB7" },
        { title: "Light Purple", color: "#E1BEE7" },
        { title: "Indigo", color: "#3F51B5" },
        { title: "Blue", color: "#2196F3" },
        { title: "Light Blue", color: "#03A9F4" },
        { title: "Cyan", color: "#00BCD4" },
        { title: "Teal", color: "#009688" },
        { title: "Green", color: "#4CAF50" },
        { title: "Light Green", color: "#8BC34A" },
        { title: "Dark Green", color: "#1B5E20" },
        { title: "Yellow", color: "#FFEB3B" },
        { title: "Brown", color: "#795548" },
        { title: "Lime", color: "#CDDC39" },
        { title: "Amber", color: "#FFC107" },
        { title: "Orange", color: "#FF9800" },
        { title: "Deep Orange", color: "#FF5722" },
        { title: "Grey", color: "#607D8B" },
        { title: "Neutral Grey", color: "#9E9E9E" },
      ],
    };
  },
  components: {
    draggable,
    ItemForm,
  },
  props: {
    itemModel: {
      type: Object,
      default: () => {},
    },
    children: {
      required: true,
      type: Array,
      default: () => [],
    },
    hideChildren: {
      type: Boolean,
      default: false,
    },
    attrs: Object,
    depth: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: "",
    },
    id: {
      type: Number,
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
  },
  computed: {
    computedSize() {
      if (this.attrs.type === "large") {
        return "text-h5";
      }
      if (this.attrs.type === "medium") {
        return "text-h6";
      }
      if (this.attrs.type === "small") {
        return "text-body-1";
      }
      if (this.attrs.type === "waterfall") {
        switch (this.depthInc) {
          case 1:
            return "text-h5";
          case 2:
            return "text-h6";
          case 3:
            return "text-body-1";
          default:
            return "text-body-2";
        }
      }
      return "text-h5";
    },
  },
  methods: {
    getName(el) {
      if (this.attrs.prefix && el.allowPrefix) {
        switch (this.attrs.prefixPosition) {
          case "after":
            return `${el.name}${this.attrs.prefix}`;
          case "after-space":
            return `${el.name} ${this.attrs.prefix}`;
          case "before":
            return `${this.attrs.prefix}${el.name}`;
          case "before-space":
            return `${this.attrs.prefix} ${el.name}`;
        }
      } else {
        return el.name;
      }
    },
    getButtonText(el) {
      return el.allowPrefix ? "Prefix on" : "Prefix off";
    },
    getButtonClass(el) {
      return el.allowPrefix ? "white" : "grey lighten-2";
    },
    editItem($event) {
      const pick = this.children.find((x) => x.id === $event.id);
      const indexOfItem = this.children.indexOf(pick);
      pick.edit = true;
      this.$set(this.children, indexOfItem, pick);
      this.newItem = { ...$event };
    },
    editCommit($event) {
      const item = this.children.find((x) => x.id === $event.id);
      const indexOfItem = this.children.indexOf(item);
      const editedItem = this.constructItem(this.itemModel, $event);
      editedItem.edit = false;
      this.$set(this.children, indexOfItem, editedItem);
      this.newItem = { ...this.itemModel };
    },
    deleteItem($event) {
      const item = this.children.find((x) => x.id === $event.id);
      const indexOfItem = this.children.indexOf(item);
      this.children.splice(indexOfItem, 1);
    },
    togglePrefix($event) {
      const item = this.children.find((x) => x.id === $event.id);
      const indexOfItem = this.children.indexOf(item);
      const editedItem = {
        ...item,
        allowPrefix: !item.allowPrefix,
      };
      this.$set(this.children, indexOfItem, editedItem);
    },
    cancelEdit($event) {
      const item = this.children.find((x) => x.id === $event.id);
      const indexOfItem = this.children.indexOf(item);
      const editedItem = {
        ...item,
        edit: false,
      };
      this.$set(this.children, indexOfItem, editedItem);
    },
    constructItem(model, item) {
      const obj = {};
      Object.keys(model).forEach((key) => {
        obj[key] = checkPopulated(item[key]);
      });
      return obj;
    },
  },
};
</script>

<style lang="scss" scoped>
.circle {
  width: 30px;
  height: 30px;
  background: grey;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  position: relative;
}
.pre-wrap {
  white-space: pre-wrap;
}
.dragArea {
  min-height: 20px;
  li {
    list-style: none;
    background: white;
    padding-left: 1rem;
    background: white;
    margin: 0px 0 0px 0;
    background: rgb(240, 240, 240);
    padding-right: 0rem;
    cursor: pointer;
    border-top: white 1px dotted;
    border-left: white 4px solid;
    ul {
      li {
        background: rgb(230, 230, 230);
        ul {
          margin-bottom: 0px;
          li {
            background: rgb(220, 220, 220);
          }
          ul {
            li {
              background: rgb(210, 210, 210);
            }
            ul {
              li {
                background: rgb(200, 200, 200);
              }
              ul {
                li {
                  background: rgb(190, 190, 190);
                }
              }
            }
          }
        }
      }
    }
  }
  padding: 0;
  margin: 0px;
  margin-bottom: 0.5rem;
}
</style>
